"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Dependencies

class Search extends _react.default.Component {
  render() {
    if (!this.props.hasSearch) {
      return /*#__PURE__*/_react.default.createElement("div", null);
    }
    const searchBoxStyles = {
      position: 'relative',
      height: this.props.searchOpen ? '73px' : '0',
      overflow: 'hidden',
      width: 'calc(100% + 30px)',
      marginLeft: '-15px',
      backgroundColor: '#000',
      transition: 'all 0.3s ease-in-out',
      display: this.props.open && this.props.isMobile ? 'none' : 'block'
    };
    const inputStyles = {
      margin: '0',
      width: '100%',
      padding: '11px 6px 6px',
      textDecoration: 'none',
      fontSize: '20px',
      lineHeight: '19px',
      fontWeight: 300,
      color: '#fff',
      outline: 'none',
      backgroundColor: 'transparent',
      border: '1px solid #707070',
      boxShadow: 'none',
      borderRadius: '3px'
    };
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "mobile-menu-search-box hidden-lg",
      style: searchBoxStyles
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "container"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "col-sm-12",
      style: {
        padding: 0
      }
    }, /*#__PURE__*/_react.default.createElement("form", {
      id: "mobile-menu-search-form",
      action: '/search',
      style: {
        padding: '15px 0'
      }
    }, /*#__PURE__*/_react.default.createElement("input", {
      id: "e-search-input",
      name: "sqs",
      size: "30",
      maxLength: "128",
      placeholder: this.props.placeholder,
      style: inputStyles
    })))));
  }
}
exports.default = Search;
Search.propTypes = {
  placeholder: _propTypes.default.string,
  hasSearch: _propTypes.default.bool,
  isMobile: _propTypes.default.bool,
  searchOpen: _propTypes.default.bool,
  open: _propTypes.default.bool
};
Search.defaultProps = {
  placeholder: 'Search',
  hasSearch: false
};